import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import meanStackImage from '../../images/cardpageimages/technicalcourse/meanstack.jpg';
import IntroVideos from "../../componants/introvideos";
import MeanStackModule from "../../componants/allCourseModule/TechnicalCourseModule/MeanStackModule";

function MeanStack() {
  return (
    <>
      <Header />
      <BannerForAll
        title="MEAN STACK FULL COURSE"
        text="Our MEAN Stack Full Course offers comprehensive training in MongoDB, Express.js, Angular, and Node.js. Learn how to develop full-stack web applications, covering everything from back-end databases to front-end user interfaces. Ideal for aspiring full-stack developers, this course equips you with the skills to build, deploy, and maintain dynamic web applications using the MEAN stack."
        imageone={meanStackImage}
        imagetwo={meanStackImage}
      />
      <IntroVideos
        vone="https://www.youtube.com/embed/dQw4w9WgXcQ"
        vtwo="https://www.youtube.com/embed/3JZ_D3ELwOQ"
        topic="MEAN STACK"
      />
      <MeanStackModule />
      <Footer />
    </>
  );
}

export default MeanStack;
